import { t } from 'ttag'
import { useMutation, useQueryClient } from 'react-query'

import { Field } from '@h2/components/inputs/field'
import { TextInput } from '@h2/components/inputs/text'
import { Button } from '@h2/components/buttons/button'
import { api } from '@h2/api'
import { useForm } from '@h2/common/components/hooks/useForm'
import { showUserFeedback } from '@h2/common/actions/showUserFeedback'
import { useNavigator } from '@h2/common/components/hooks/useNavigator'
import { Box } from '@h2/components/layout/box'

const CreateGroup = ({ onCreate }) => {
  const { register, dispatch, handleOnSubmit } = useForm()
  const queryClient = useQueryClient()
  const navigator = useNavigator()
  const { mutate, isLoading } = useMutation(
    form => {
      return api.fetch('/admin/users/groups/create', {
        version: 'v1',
        method: 'POST',
        body: JSON.stringify(form)
      })
    },
    {
      onSuccess: rslt => {
        queryClient.setQueriesData([`groups`], oldData => {
          if (!oldData) {
            return oldData
          }

          return [...oldData, rslt]
        })

        if (onCreate) {
          onCreate()
        }

        navigator(`/management/groups/${rslt.id}`)
      },
      onError: error => {
        dispatch(
          showUserFeedback(t`An error occurred while trying to create group`, 'error')
        )

        return error
      }
    }
  )

  return (
    <form onSubmit={handleOnSubmit(form => mutate(form))}>
      <Field isRequired={true} label={t`Group to Add`} style={{ width: '100%' }}>
        <TextInput {...register('name', { required: true })} />
      </Field>
      <Box margin="15px 0">
        <Button size="large" type="submit" isLoading={isLoading}>
          {t`Add to Group`}
        </Button>
      </Box>
    </form>
  )
}

export { CreateGroup }
